import React, { useState, useContext, useMemo } from "react";
import DataTable from "./../../../Layout/Table/TableLayout";
import Navbar from "../../../Shared/ManagerNavbar/Navbar";
import "./MyTeam.css";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { baseURL } from "../../../Apiservices/Api";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../../Loader/Loader";

const MyTeam = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { authToken, userId } = useContext(AuthContext);

  // ===============================
  // FETCH TEAM MEMBERS
  // ===============================
  const {
    data: team = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["my-team", userId],
    refetchInterval: 3000, // Refetch every 3 seconds to keep data updated
    queryFn: async () => {
      if (!authToken || !userId) return [];

      const response = await fetch(
        `${baseURL}/employees/${userId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch employees data");
      }

      return response.json();
    },
    enabled: !!authToken && !!userId,
    keepPreviousData: true,
  });

  // ===============================
  // TABLE COLUMNS
  // ===============================
  const columns = useMemo(
    () => [
      {
        Header: "Employee ID",
        accessor: "id",
        Cell: ({ value }) =>
          `EMP${String(value).padStart(5, "0")}`,
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Designation",
        accessor: "role",
        Cell: ({ value }) =>
          value === "employee"
            ? "Associate - Sales & Operations"
            : value,
      },
    ],
    []
  );

  return (
    <div className="manager-myteamcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div
        className={`manager-myteam ${
          collapsed ? "collapsed" : ""
        }`}
      >
        <div className="manager-myteam-container mb-5">
          <div className="manager-myteam-table-container">
            <h2 className="text-center">My Team</h2>

            {isLoading ? (
              <Loader />
            ) : isError ? (
              <div className="text-danger text-center p-4">
                {error?.message}
              </div>
            ) : (
              <DataTable
                columns={columns}
                data={team}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyTeam;
